import React from "react";
import './HelpPage.css';

const HelpPage = () => {
    return (
        <div className="help-page">
            <div className='container '>
                {/* <Link to="/" className=''>ГЛАВНАЯ</Link> */}

                <p>
                    Приложение помогает взвесить приоритеты из нескольких задач И сортирует их по порядку.
                </p>

                <p>
                    Как это работает:
                </p>

                <p>
                   - Добавление задач как в обычный тайм менеджер. Вводя нажать "Ввод", чтобы задача отобразилась в списке.
                </p>
                
            </div>

            <div className="container"> <img src='./help1.png' /> </div>
            <div className="container">
                <p>
                    - После добавления минимум 2 задач, появляется раздел, где можно выбрать, какая задаче приоритетнее.
                    Справа сверху кнопка для обновления, чтобы отобразить другие задачи.
                </p>
            
                <p>
                Максимальный приоритет равен 20, один клик добавляет +1 у нажатой задачи и убирает 0.3 у не нажатой.
                Задачи сортируются сверху вниз по убыванию рейтинга, так же окраска зависит от приоритета.
                </p>
            </div>
            <div className="container"> <img src='./help2.png' /> </div>

            <div className="container">
                <p>
                    - Кнопка справа удаляет элемент, нажатие по задаче переводит её в выполненные, работает в обе стороны.
                </p>
                <p>
                    Удерживание элемента от 1 секунды, после отпускания, открывает поле редактирования элемента. Ввод подтверждает изменения.
                </p>
            </div>
            <div className="container"> <img src='./help3.png' /> </div>
        </div>
    );
};

export default HelpPage;
